import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { getApi } from '../../Services/apiService';

export default function OfferDetail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });

  const { id } = useParams(); // Extract the offer ID from the URL
  const [offer, setOffer] = useState(null); // Initialize offer as null

  useEffect(() => {
    fetchOffer();
  }, [id]);

  const fetchOffer = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getApi(`/admin/offer/${id}`); // Fetch offer by ID
      setOffer(response.data); // Set the fetched offer data
      console.log("Fetched Offer:", response.data);
    } catch (err) {
      console.error('Failed to fetch offer:', err);
      setError('Failed to load offer');
    } finally {
      setLoading(false);
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return 'Redeemed';
      case 1:
        return 'Used';
      case 2:
        return 'Expired';
      default:
        return 'Pending';
    }
  };

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedUsers = [...(offer?.Redeem_Offers || [])].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setOffer((prevOffer) => ({
      ...prevOffer,
      Redeem_Offers: sortedUsers,
    }));
  };

  const formatDate = (date) => {
    return date ? moment(date).format('DD/MM/YYYY') : 'NA';
  };

  const filteredRedeemOffers = offer?.Redeem_Offers?.filter((redeem) =>
    redeem?.User?.name?.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <>
      {loading && (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      )}
      {error && <p className="error-message">{error}</p>}

      <div className="RightSideDiv">
        <div className="car-care-tips">
          <div className="right-top">
            <div className="d-flex gap-3 justify-content-end">
              <input
                type="text"
                className="search-input"
                placeholder="Search . . ."
                value={query}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div className="table-outer">
            <table className="table">
              <thead>
                <tr className="t-heading">
                  <th className="sr-no">
                    <h5>No</h5>
                  </th>
                  <th className="order" onClick={() => handleSort('name')}>
                    <h5>Name</h5>
                  </th>
                  <th className="order" onClick={() => handleSort('user_name')}>
                    <h5>User Name</h5>
                  </th>
                  <th className="info" onClick={() => handleSort('email')}>
                    <h5>User Email</h5>
                  </th>
                  <th className="order" onClick={() => handleSort('status')}>
                    <h5>Status</h5>
                  </th>
                  <th className="order" onClick={() => handleSort('code')}>
                    <h5>Coupon Code</h5>
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredRedeemOffers?.length > 0 ? (
                  filteredRedeemOffers.map((redeem, index) => (
                    <tr className="green" key={index}>
                      <td className="sr-no">
                        <h5>{index + 1}</h5>
                      </td>
                      <td className="order">
                      <span>                        
                        <img
                          src={redeem?.User?.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                          alt="Profile"
                          className="profile-thumbnail"
                        />
                        </span>
                      <h5> 
                      {redeem?.User?.name || 'N/A'}
                      </h5>

                      

                      
                      </td>
                      <td className="order">
                        <h5>{redeem?.User?.user_name || 'N/A'}</h5>
                      </td>
                      <td className="info">
                        <h5>{redeem?.User?.email || 'N/A'}</h5>
                      </td>
                      <td className="info">
                        <h5>{getStatusLabel(redeem?.status)}</h5>
                      </td>
                      <td className="info">
                        <h5>{redeem?.code || 'N/A'}</h5>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      <div className='alert alert-danger'>No Users Found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}